const deck = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M22 9L12 2L2 9H11V22H13V9H22ZM4.13969 12L2.17969 12.37L2.99969 16.74V22H4.99969L5.01969 18H6.99969V22H8.99969V16H4.89969L4.13969 12ZM15 16H19.1L19.86 12L21.82 12.37L21 16.74V22H19L18.98 18H17V22H15V16Z" fill="black" />
  </svg>
);
export default deck;
